import { render, staticRenderFns, recyclableRender, components } from "./notice.vue?vue&type=template&id=0b680ac6&scoped=true&"
var renderjs
import script from "./notice.vue?vue&type=script&lang=js&"
export * from "./notice.vue?vue&type=script&lang=js&"
import style0 from "./notice.vue?vue&type=style&index=0&id=0b680ac6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../办公/HBuilderX.3.8.12.20230817/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b680ac6",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/notice/notice.vue"
export default component.exports